import { ChangeDetectorRef, Inject, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Subscription } from "rxjs";
import { ILanguageStateService } from "@zaeper/localization-lib";
import { requiresRoleHint, roleDescription, roleName, TCompanyRole } from "@zaeper/core-lib";
import { languageStateServiceInjectionToken } from "../services/language/languageStateServiceInjectionToken";

/**
 * A company role's text from the shared role matrix (core-lib) in the dashboard's language: its name, its
 * one-sentence description, or the hint on an action that needs it ("Requires the Manager role – ask an admin…").
 */
@Pipe({
	name: "zRole",
	pure: false
})
export class RoleTextPipe implements PipeTransform, OnDestroy {
	private _language: string = "de";
	private readonly _subscription: Subscription;

	constructor(
		@Inject(languageStateServiceInjectionToken) languageStateService: ILanguageStateService,
		changeDetectorRef: ChangeDetectorRef
	) {
		this._subscription = languageStateService.language$.subscribe((language: string) => {
			this._language = language;
			changeDetectorRef.markForCheck();
		});
	}

	transform(role: TCompanyRole | null | undefined, text: "name" | "description" | "hint" = "name"): string {
		if (!role) return "";
		switch (text) {
			case "description":
				return roleDescription(role, this._language);
			case "hint":
				return requiresRoleHint(role, this._language);
			default:
				return roleName(role, this._language);
		}
	}

	ngOnDestroy(): void {
		this._subscription.unsubscribe();
	}
}
